export default __webpack_public_path__ + "static/media/logo-dark.659d5d8b.svg";